// تسميات تقرير الرواتب (ثنائية اللغة) — مستقلة عن i18n لأن الـ HTML يُحقن في نافذة جديدة.
import { COMMON } from "./reportLabelsCommon";

export const L = {
  ar: {
    ...COMMON.ar,
    sealedBadge: "مختوم — مدفوع ومؤكَّد",
    signRoles: ["أعدّه (الموارد البشرية)", "راجعه (المالية)", "اعتمده (المدير العام)"],
    signNote: "هذا التقرير صادر إلكترونياً من نظام HELCOO، والأرقام الواردة فيه مأخوذة من السجل الرسمي للحضور والرواتب.",
    titleOne: "كشف راتب الموظف",
    titleMany: "تقرير الرواتب الشهري",
    titleCustom: "تقرير الرواتب - فترة مخصصة",
    allBranches: "جميع الفروع",
    month: "الشهر المحاسبي",
    periodTo: "إلى",
    generatedAt: "تاريخ إنشاء التقرير",
    payDay: "يوم الصرف",
    days: "يوم",
    dayOf: "اليوم",
    compNote: "أيام تعويض قاعدة الـ30:",
    cards: ["إجمالي الموظفين", "الراتب الأساسي الإجمالي", "المستحق حتى الآن", "المتوقع نهاية الشهر"],
    cardsCustom: ["عدد الموظفين", "الراتب الأساسي", "البدلات", "صافي المستحق"],
    cols: ["الموظف", "الراتب الأساسي", "الراتب اليومي", "أيام العمل", "العطل (كلي/مدفوع)", "الإجازات", "التعويض",
      "إجمالي مدفوع", "الغياب", "التأخير", "الخصومات", "قسط السلفة", "المستحق الصافي"],
    remote: "عن بُعد",
    office: "مكتبي",
    leaveTypes: { annual: "سنوية", sick: "مرضية", emergency: "طارئة", unpaid: "غير مدفوعة" },
    explainTitle: "شرح الحسابات",
    explain: [
      ["عمود العطل (كلي/مدفوع)", "الرقم الأول إجمالي العطل الأسبوعية في الفترة، والثاني ما احتُسب مدفوعاً فعلياً."],
      ["إجمالي مدفوع", "أيام العمل + العطل المدفوعة + الإجازات المدفوعة + أيام التعويض."],
      ["خصم الغياب", "عدد أيام الغياب × مضاعف الغياب (×{m}) × الراتب اليومي."],
      ["خصم التأخير", "عدد مرات التأخير الرسمي × الراتب اليومي."],
      ["المستحق", "(إجمالي مدفوع × الراتب اليومي) − الخصومات + المكافآت."],
    ],
    warnTitle: "⚠️ ملاحظة هامة حول العطل غير المدفوعة",
    weekendIs: "أيام العطلة الأسبوعية لهذا الفرع:",
    paidWhen: "تُحتسب العطلة مدفوعة إذا حضر الموظف يوم العمل السابق للعطلة واللاحق لها، أو وقعت العطلة داخل إجازة سنوية معتمدة.",
    notPaidWhen: [
      "وجود غياب في اليوم المحيط بالعطلة.",
      "إجازة مرضية أو طارئة غير مدفوعة قبل العطلة أو بعدها.",
      "غياب تسجيل الحضور في الأيام المحيطة بالعطلة.",
    ],
    footer: "تم إنشاء هذا التقرير بواسطة نظام إدارة الرواتب",
    weekdays: ["الاثنين", "الثلاثاء", "الأربعاء", "الخميس", "الجمعة", "السبت", "الأحد"],
    none: "—",
  },
  en: {
    ...COMMON.en,
    sealedBadge: "Sealed — paid and acknowledged",
    signRoles: ["Prepared by (HR)", "Reviewed by (Finance)", "Approved by (General Manager)"],
    signNote: "This report was issued electronically by HELCOO; its figures come from the official attendance and payroll record.",
    titleOne: "Employee Salary Statement",
    titleMany: "Monthly Salary Report",
    titleCustom: "Salary Report - Custom Period",
    allBranches: "All branches",
    month: "Accounting month",
    periodTo: "to",
    generatedAt: "Generated on",
    payDay: "pay day",
    days: "days",
    dayOf: "Day",
    compNote: "30-day rule compensation:",
    cards: ["Total employees", "Total basic salary", "Accrued to date", "Expected end of month"],
    cardsCustom: ["Employees", "Basic salary", "Allowances", "Net payable"],
    cols: ["Employee", "Basic salary", "Daily rate", "Work days", "Weekends (all/paid)", "Leaves", "Compensation",
      "Total paid", "Absence", "Late", "Deductions", "Advance", "Net accrued"],
    remote: "Remote",
    office: "Office",
    leaveTypes: { annual: "Annual", sick: "Sick", emergency: "Emergency", unpaid: "Unpaid" },
    explainTitle: "How the figures are calculated",
    explain: [
      ["Weekends (all/paid)", "First number is all weekly days off in the period, second is those actually paid."],
      ["Total paid", "Work days + paid weekends + paid leaves + compensation days."],
      ["Absence deduction", "Absence days × absence multiplier (×{m}) × daily rate."],
      ["Late deduction", "Official late occurrences × daily rate."],
      ["Net accrued", "(Total paid × daily rate) − deductions + bonuses."],
    ],
    warnTitle: "⚠️ Important note about unpaid weekends",
    weekendIs: "Weekly days off for this branch:",
    paidWhen: "A weekend is paid when the employee attended the working day before and after it, or the weekend falls inside approved annual leave.",
    notPaidWhen: [
      "An absence on the day surrounding the weekend.",
      "Unpaid sick or emergency leave before or after the weekend.",
      "No attendance record on the surrounding days.",
    ],
    footer: "Generated by the payroll management system",
    weekdays: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
    none: "—",
  },
};
